import parsePhoneNumber from "libphonenumber-js/mobile";
import { styleToClass as styleToClassUtil } from "~/utils/styleToClass.js";

export default{

  computed: {
    baseGraphURL()
    {
      return window.location.hostname.includes('--aws--') ? process.env.VUE_APP_API_GRAPH_URL_AWS : process.env.VUE_APP_API_GRAPH_URL;
    },
  },



  methods:{


	////////////////////////////////////////////////////////////////
	//
	// Element styles
	//
	////////////////////////////////////////////////////////////////





	/**
	 * Returns base styles for element within a theme
	 * @type {string} theme to style with
	 * @type {string} component name
	 * @type {string} id of element
	 * @return {Object} of styles
	 */


	baseStyles()
	{
		return {};
	},


  promoCodeIsGiftcard(code)
  {
    return false; // this function is deprecated, we no longer except gift cards as payment
    if(code)
      return code.substring(0, 8) == process.env.VUE_APP_INN_PREFIX;
  },


  /**
     * Get data that we need from the API on initial load of app
     * @return void
     */


    getStoreLoadData()
    {

      return new Promise(
        (resolve, reject) => {

        this.$store.commit('SET_STORE_LOADING',true);



        $axios({
          url: this.baseGraphURL+'/cached',
          method: 'post',
          data: {
            query: `
                query($domain:String, $product_active:Int, $postage_type_active:Int, $store_type_id:Int, $order_by: String){
                    Accounts(domain:$domain){

                      tag_manager_container,
                      ga_tracking_id,

                      id,
                      domain,
                      show_promotional_code_input,
                      default_domain,
                      name,
                      website,
                      privacy_policy_url,
                      terms_url,
                      contact_url,
                      page_text,
                      footer_text,
                      order_confirmation_heading,
                      order_confirmation_text,
                      toggle_fulfilment,
                      storeLive,
                      blockSearchEngineIndexing,
                      purchase_terms_active,
                      phone_number_for_orders_active,
                      purchase_terms_text,
                      custom_message_for_postal_products_active,
                      should_resize_webshop_logo,
                      PaymentProviderAccount{
                        payment_provider_id,
                        PaymentProviderAccountConfigs{
                          payment_provider_attribute_id,
                          content
                        }
                      },
                      Image{
                        url
                      },
                      Consents{
                        id,
                        consent_copy,
                        is_active
                      },
                      PostageTypes(active:$postage_type_active){
                        id,
                        max_value,
                        max_quantity,
                        Currency{
                          id,
                          denomination,
                          symbol
                        },
                        delivery_name,
                        price,
                        tracked
                      },
                      Bundles(page:1, limit:100, active:$product_active){

                        data{
                          id,
                          price,
                          name,
                          slug,
                          short_description,
                          long_description,
                          active,
                          Image{
                            url
                          },
                          Currency{
                            id,
                            denomination,
                            symbol
                          },
                          PriceModifiers{
                            id,
                            description,
                            price,
                            Product{
                              id,
                              name,
                              FulfilmentMethods{
                                id,
                                name
                              }
                            }

                          }
                        },
                        total,
                        per_page

                      },
                      Products(active:$product_active, store_type_id:$store_type_id, order_by:$order_by){
                        id,
                        name,
                        webshop_order,
                        slug,
                        short_description,
                        long_description,
                        active,
                        show_on_storefront,
                        display_remaining_at,
                        CurrentExpiryConfig{
                          seconds_valid_for,
                          hard_expire_at
                        },
                        PostageTypes{
                          id,
                          max_value,
                          max_quantity,
                          Currency{
                            id,
                            denomination,
                            symbol
                          },
                          PostageCategory{
                            id,
                            name

                          },
                          delivery_name,
                          price,
                          tracked
                        },
                        AutomaticPromotions(limit:10, page:1){
                          data{
                            id,
                            display_text,
                            display_text_long
                          },
                          total,
                          per_page
                        },
                        ValidityRules{
                          rule,
                          validity_rule_type_id
                        },
                        Image{
                          url
                        },
                        ProductType{
                          id,
                          name
                        },
                        FulfilmentMethods{
                          id,
                          name
                        },
                        PriceModifiers{
                          id,
                          price,
                          description,
                          Currency{
                            id,
                            denomination,
                            symbol
                            id,
                            denomination,
                            symbol
                          }
                        },
                        allow_personal_message,
                        num_message_chars_per_line,
                        num_message_lines
                      },
                      Collections{
                        id,
                        name,
                        description,
                        slug,
                        show_on_tile,
                        show_on_dropdown,
                        active,
                        Images{
                          id,
                          url
                        },
                        Products{
                            id
                        },
                        Bundles{
                            id
                        },
                        webshop_order
                      },
                      TimeConfig {
                          date_format
                      }
                    },
                    AccountStyles{name, Components{id, name, ThemeElements{id, element_reference, ThemeElementStyles(domain:$domain){id, property, value}}}},
                    AccountFonts(domain:$domain){font_library},
                }
              `,
            variables: {
                domain: window.location.hostname,
                product_active: 1,
                postage_type_active: 1,
                store_type_id:1,
                order_by: 'webshop_order'
            }
          }
        }).then((result) => {

            this.$store.commit('SET_STORE_LOADING',false);

            if(!result.data.data.Accounts.length){
              this.$store.commit("RESET_STORE");
              this.$store.commit('SET_STORE_LOADING',false);
              this.$router.push({name:'notfound'});
              return;
            }

            // if the user visited the default domain and there is a custom domain setup, redirect there.
            if(result.data.data.Accounts[0].domain != window.location.hostname && window.location.hostname == result.data.data.Accounts[0].default_domain)
              window.location.href = 'https://'+result.data.data.Accounts[0].domain+window.location.pathname;

            this.$store.commit("SET_STORE_STATUS",result.data.data.Accounts[0].storeLive);
            this.$store.commit("SET_BLOCK_SEARCH_ENGINE_INDEXING", result.data.data.Accounts[0].blockSearchEngineIndexing);

            if(!result.data.data.Accounts[0].storeLive)
              this.$store.dispatch('storeOffline', this.$router);

            this.$store.commit("SET_ACCOUNT",result.data.data.Accounts[0]);
            this.$store.commit('SET_CUSTOM_STYLES', this.formatCustomStyles(result.data.data.AccountStyles));
            this.$store.commit('SET_ACCOUNT_FONTS', result.data.data.AccountFonts[0].font_library);

            let account_name = this.$store.getters.getAccount.name;
            if(!document.title.includes(account_name))
              document.title = account_name+' - '+document.title;


            // set the correct payment library
            /*let payment_script = document.createElement("script");
            payment_script.type = "text/javascript";
            payment_script.src = "https://js.stripe.com/v3/";
            payment_script.innerHTML = "";
            document.getElementById("payment_script").innerHTML = "";*/


            /*if(this.$store.getters.getAccount.PaymentProviderAccount){
              switch (this.$store.getters.getAccount.PaymentProviderAccount.payment_provider_id){
                case 1:
                  payment_script.src = "https://js.stripe.com/v3/";
                  break;
                case 2:
                  payment_script.src = "https://webservices.securetrading.net/js/st.js";
                  break;
                case 3:
                  payment_script.src = "https://webservices.securetrading.net/js/v2/st.js";
                  break;
                case 4:
                  payment_script.src = process.env.VUE_APP_STATIC_URL+"/frontend/js/rxp-js.js";
                  break;
                default:
                  // code block
              }
            }

            document.getElementById("payment_script").appendChild(payment_script);*/

            setTimeout(() => {
              this.$store.commit('SET_PAYMENT_GATEWAY_LOADED',true)
            }, 20);


            this.syncLocalData();
              var accData = result.data.data.Accounts[0];

            var tracking_ids = {
                tag_manager_container : false,
                ga_tracking_id : false
            }

            if (accData.tag_manager_container) tracking_ids.tag_manager_container = accData.tag_manager_container;
            if (accData.ga_tracking_id) tracking_ids.ga_tracking_id = accData.ga_tracking_id;
            resolve(tracking_ids);
        }).catch((error) => {
          this.$bus.$emit('show_modal_alert',"Something has gone wrong, please try again.");
          reject(error); // reject
        }).then(()=>{
          this.$store.commit('SET_STORE_LOADING',false);
        });

      });
    },

  /**
   * If the current account has a google analytics tracking id or a tag manager account setup, get it
   * @returns promise - success object with tracking ids
   */

  getAnalytics(){

    return new Promise(
        function (resolve, reject) {

          window.axios({
              url: this.baseGraphURL,
                method: 'post',
                data: {
                  query: `
                      query($domain:String){
                          Accounts(domain:$domain){
                            tag_manager_container,
                            ga_tracking_id
                          }
                      }
                    `,
                  variables: {
                      domain: window.location.hostname,
                  }
                }
          }).then((result) => {
            if(result.data.data.Accounts.length){
              var accData = result.data.data.Accounts[0];
              var tracking_ids = {
                tag_manager_container : false,
                ga_tracking_id : false
              }

              if (accData.tag_manager_container) tracking_ids.tag_manager_container = accData.tag_manager_container;
              if (accData.ga_tracking_id) tracking_ids.ga_tracking_id = accData.ga_tracking_id;
              resolve(tracking_ids);

            }
            resolve(false);
          }).catch((error) => {
              reject(error); // reject
          });





    });

    /*;*/

  },


  /**
   * Logs an event to the api
   * @param {string} message to log
   * @param {array} broadcast ids to send the log on: 1 -
   */

  sendEvent(message, broadcast_ids){

    window.axios({
        url: this.baseGraphURL,
        method: 'post',
        data: {
        query: `
            mutation($message:String!, $broadcast_ids:[Int]!, $app_id:Int!) {
                createEvent(message:$message, broadcast_ids:$broadcast_ids, app_id:$app_id)
            }
          `,
          variables: {
            message      : message,
            broadcast_ids: broadcast_ids,
            app_id       : process.env.VUE_APP_WEBSTORE_APP_ID
          }
        }
    }).catch(() => {
        this.$bus.$emit('show_modal_alert',"Something has gone wrong, please try again.");
    });

  },



	/**
	 * Returns override custom styles for element within a theme
	 * @type {string} theme to style with
	 * @type {string} component name
	 * @type {string} id of elemen
	 * @return {Object} of styles
	 */

	overrideStyles(theme, component, element_id)
	{
		return this.$store.getters.getStylesById(theme, component, element_id);
	},

	/**
	 * Returns the CSP-safe class name for a theme element (used with nonced <style> block).
	 * Must match class names generated by csp-theme-styles.client.js plugin.
	 * @type {string} theme
	 * @type {string} component
	 * @type {string} element_id
	 * @return {string} class name e.g. sf-vanilla-StoreFront-description-text
	 */
	styleMeClass(theme, component, element_id)
	{
		const sanitize = (part) => String(part || '').replace(/[\s.]+/g, '-').replace(/[^a-zA-Z0-9-_]/g, '') || 'x';
		return `sf-${sanitize(theme)}-${sanitize(component)}-${sanitize(element_id)}`;
	},

	/**
	 * Styles a given element (inline; use styleMeClass for CSP-safe class instead).
	 * @type theme {string} theme to style with
	 * @type component {string} component name
	 * @type element_id {string} id of element
	 * @return array of objects [{base stle sheet}, {overriding style sheet}]
	 */
	styleMe(theme, component, element_id)
	{
		return [this.baseStyles(), this.overrideStyles(theme, component, element_id)]
	},

	/**
	 * CSP-safe: injects style object or string into nonced <style> and returns a class name.
	 * Use :class="styleToClass(...)" instead of :style to avoid style-src-attr violations.
	 */
	styleToClass(style)
	{
		return styleToClassUtil(style)
	},

	////////////////////////////////////////////////////////////////
	//
	// Store product selection functionality
	//
	////////////////////////////////////////////////////////////////


	/*setMouseDown(event){
        if(!this.expanded && !this.mousedown)
            if(event.type == 'touchstart'){
                this.mousedown = true;
            }
    },*/

    /**
     * Get the display value of a price modifier
     * @type {Object} Price Modifier
     * @type {integer} Qunatity
     * @return String
     */

    getPriceModifierDisplayValue(price_modifier, quantity)
    {
        if(price_modifier && (price_modifier !== "Custom"))
          return this.getPriceDisplayValue(price_modifier.price, quantity);
        return 0;
    },

    /**
     * Get the display value of a currency
     * @type {string} Symbol
     * @type {integer} Price
     * @type {integer} Quantity
     * @type {integer} currency denomination
     * @return String
     */

    getPriceDisplayValue(price, quantity)
    {

      let account = this.$store.getters["getAccount"];
      return ((price*quantity)/account.Currency.denomination).toLocaleString(account.currency_locale, {style: 'currency', currency: account.Currency.iso_currency_code});

    },

    /**
     * Get the display value of a currency without trailing zeros eg. £10.00 is displayed as £10, but £7.50 still displayed as £7.50
     * @type {string} Symbol
     * @type {integer} Price
     * @type {integer} Quantity
     * @type {integer} currency denomination
     * @return String
     */

     getPriceDisplayValueNoTrailingZeros(price, quantity)
     {

       let account = this.$store.getters["getAccount"];
       let amount = (price*quantity)/account.Currency.denomination;

       if (Number.isSafeInteger(amount)) {
          return amount.toLocaleString(account.currency_locale, {style: 'currency', currency: account.Currency.iso_currency_code, minimumFractionDigits: 0});
       } else {
          return amount.toLocaleString(account.currency_locale, {style: 'currency', currency: account.Currency.iso_currency_code});
       }

     },

     displayPostageFee(price)
     {
       let account = this.$store.getters["getAccount"];
       return ((price)/account.Currency.denomination).toLocaleString(account.currency_locale, {style: 'currency', currency: account.Currency.iso_currency_code});

     },


    /**
     * Get A Product form the store By Its ID
     * @type {DOM element} Element of product
     */

    getProductByID(id)
    {
        var product = this.$store.getters.getProductById(id);
        if(product !== undefined)
            return product;
        return false;
    },

    syncLocalData()
    {

        var basket             = this.$store.getters['basket/getBasket'];
        var available_products = this.$store.getters.getProducts;
        var available_postage_types = this.$store.getters.getPostageTypes;

        for (let i = 0; i < basket.length; i++)
          if(
            // If we have a product that is in the basket, but no longer available in the store, remove it
            available_products.find(x => x.id === basket[i].id) === undefined ||
            // If we have a product that is in the basket, but with a price modifer that no longer exists (and if it has a price modifier and not a custom price modifier), remove it
            (basket[i].price_modifier && available_products.find(x => x.id === basket[i].id).PriceModifiers.find(y => y.id === basket[i].price_modifier) === undefined) ||
            // If we have a product that is in the basket and set with a custom price modifier but custom_price_modifiers are no longer allowed
            (basket[i].custom_price_modifier_value && available_products.find(x => x.id === basket[i].id).allow_custom_price_modifier == false) ||
            // if we have a product with postage fulfilment and there are no postage types available, remove it.
            (basket[i].delivery_type == 2 && !available_postage_types.length)
            ) this.$store.commit('basket/REMOVE_FROM_BASKET',i);

    },

    /**
     * If an order is attempted and items are out of stock, then show a popup and send back to shop home
     * @return void
     */

    outOfStockJourney()
    {
       // this.$bus.$emit('show_modal_alert',"Sorry, there were items in your basket that became unavailable since you started making payment. Your card has not been charged.");
        this.$store.dispatch('resetStore');
        this.$router.push({ name: 'soldout'});
    },




    getPostcodes(postcode)
    {
        // Mock API
        var addresses = [];

        var streetNames = ['Hollywood Boulevard', ' South Street', ' Abbey Road'];

        var streetName = streetNames[Math.floor(Math.random() * streetNames.length)];

        var iteration = 0;

        while(iteration < 17){
            iteration++;


            var address = {
                address_line_1:iteration+' '+streetName,
                address_line_2:'',
                town_city:'Sheffield',
                postcode:postcode,
            };


            addresses.push(address);


        }

        return addresses;
    },


    /**
     * Converts a string date into a js date
     * @param  {[string]} date [string date either yyyy-mm-dd hh:mm:ss or yyyy-mm-dd
     * @return {[date]}      [javascript date]
     */
    sqlDateToJS : function(date)
    {
        if(date instanceof Date)
            return date;
        var t = date.split(/[- :]/);
        let d = null;
        if(t.length == 6)
            d = new Date(Date.UTC(t[0], t[1]-1, t[2], t[3], t[4], t[5]));
        else
            d = new Date(Date.UTC(t[0], t[1]-1, t[2]));
        return d;
    },


    // sql date to display date
    displayDate(date)
    {
        return this.$moment.utc(date).local().format(
            this.phpDateFormatToJs(this.$store.getters.getAccountDateFormat, { separator: '/' })
        );
    },


    /**
     * Converts a javascript date into a local time date string
     * @param  {[string]} date [javascript date]
     * @return {[date]}      [string date yyyy-mm-dd]
     */
    jsDateToString(date)
    {
        return ('00' + date.getDate()).slice(-2)+'/'+
        ('00' + (date.getMonth() + 1)).slice(-2)+'/'+
        date.getFullYear();
    },

    navigateToValidationError(result){

      let navigation_pages = {
        "discounts.0.promotion_code": "billing",
        "discounts.0.promotion_id"  : "billing",
        "total": "billing",
        "billing_address.name": "billing",
        "billing_address.address_line_1": "billing",
        "billing_address.address_line_2": "billing",
        "billing_address.town_city": "billing",
        "billing_address.postcode": "billing",
        "billing_address.country_code": "billing"
      };
      if(result.errors && result.errors.length){
        for (var i = 0, len = result.errors.length; i < len; i++) {
          if(result.errors[i].message == "validation"){
            for (var index in result.errors[i].validation){

              let starred_index = index.replace(/\.(\d+)\./g, '.*.');

              if(navigation_pages[index] || navigation_pages[starred_index]){
                // if the error is a validation error, then navigate to the page that has the validation error
                this.$store.commit('setTempValidationData',  result )

                this.$router.push({
                  name: navigation_pages[index]
                });
                return;
              }
            }
          }
        }
      }


    },


     /**
     * If there are validation errors, then sort the ones to show into the v-validate errors array.
     * any validation errors that are not customer facing, just populates a default error into the 'customError' variable.
     * any non validation error gets added to the customError variable, if it's customer facing
     * @type {object} graph response
     * @type {integer} graph api fields to local fields error map
     * @return BOOL
     */

     validateGraphResponse(result,error_to_error)
    {
        //Validation error
        if(result.errors && result.errors.length){

            for (var i = 0, len = result.errors.length; i < len; i++) {

                // the order contained items that are now out of stock, so empty the basket and show a message
                if(result.errors[i].name == 'out_of_stock'){
                    this.outOfStockJourney();
                    return false;
                }

                if(result.errors[i].message == "validation"){
                    for (var index in result.errors[i].validation){


                      //replace any .number. with .*.
                        let starred_index = index.replace(/\.(\d+)\./g, '.*.');
                        if(error_to_error[index]){
                            this.errors.add({field:error_to_error[index],msg:result.errors[i].validation[index][0]});
                        }else if(error_to_error[starred_index] && error_to_error[starred_index] !== undefined){
                          this.errors.add({field:error_to_error[starred_index],msg:result.errors[i].validation[index][0]});
                        }
                        else{
                          this.customerError = "An error occurred while trying to complete your request.";
                        }
                    }
                }
                if(result.errors[i].customer_facing === true){
                    this.customerError = result.errors[i].message;
                }

            }

            return false;
        }

        this.customerError = false;

        return true;

    },


    // still needs refiniing --- to many for loops
    formatCustomStyles(styles)
    {

        var AccountStyles = {};
        for(var i = 0; i < styles.length; i++) {
            AccountStyles[styles[i].name] = {};
            for(var c = 0; c < styles[i].Components.length; c++) {
                AccountStyles[styles[i].name][styles[i].Components[c].name] = {};
                for(var t = 0; t < styles[i].Components[c].ThemeElements.length; t++) {
                   AccountStyles[styles[i].name][styles[i].Components[c].name][styles[i].Components[c].ThemeElements[t].element_reference] = {};
                    for(var te = 0; te < styles[i].Components[c].ThemeElements[t].ThemeElementStyles.length; te++) {
                        AccountStyles[styles[i].name][styles[i].Components[c].name][styles[i].Components[c].ThemeElements[t].element_reference][styles[i].Components[c].ThemeElements[t].ThemeElementStyles[te].property] = styles[i].Components[c].ThemeElements[t].ThemeElementStyles[te].value;
                    }
                }
            }
        }

        return AccountStyles;
    },

      /**
       * Create the Google Analytics purchase object
       * @type {Object} payload - query variables
       * @return Object
       */
      getGaInfo(payload) {
        var shipping =  (this.shippingCost.price/this.shippingCost.denomination).toFixed(2);
        var denomination = 100; //Default value for currency denomination, needs refining denomination logic for total and discounts
        let gaEvent = {
          affiliation : 'Toggle',
          shipping: shipping
        };

        //Loop through the basket, add and modify necessary values for a proper display on GA
        var items = []
        this.$store.getters['basket/getBasket'].forEach((item) => {
            let new_item = {};

            let product           = this.getProductByID(item.id);
            let price_modifier    = item.custom_price_modifier_value ? null : product.PriceModifiers.filter(price_modifier => price_modifier.id === item.price_modifier).shift(); //Finds the currently used price modifier for this product

            new_item['id']        = "Product_"+product.id;
            new_item['name']      = product.name;
            new_item['brand']     = 'Toggle';
            new_item['category']  = product.ProductType.name;
            // New code below - not sure how to check
            new_item['price']     = item.custom_price_modifier_value ? (item.custom_price_modifier_value/this.account.Currency.denomination).toFixed(2) : (price_modifier.price/price_modifier.Currency.denomination).toFixed(2),
            new_item['quantity']  = item.quantity
            if (price_modifier && price_modifier.description)
              new_item['variant'] = price_modifier.description;

            items.push(new_item);
        });

        //Loop through payload, add and modify necessary values for a proper display on GA
        Object.keys(payload).map(function(key) {
          if (key === 'currency')
            gaEvent[key] = payload[key];
          if (key === 'total' )
            gaEvent['value'] =  (payload[key]/denomination).toFixed(2);
        });


        //Add discounts to items
        this.$store.getters['basket/getBasketDiscounts'].forEach(discount => {
          let price = 0;
          var discount_id = '';

          if (discount.add_or_discount_value == 'discount') {
            discount_id = "Discount_"+discount.promotion_id;
            price = (-discount.discount_value/denomination).toFixed(2);
          } else {
            discount_id = "Added_Val_"+discount.promotion_id;
          }

          let new_discount = {
            id: discount_id,
            name: discount.promotion_name,
            brand: 'Toggle',
            category: discount.promotion_code != '' ? discount.promotion_code : 'auto',
            price: price,
            quantity: 1
          }

          items.push(new_discount);
        });

        gaEvent['items'] = items;
        return gaEvent;
      },

      /**
       * Persist the pending purchase GA info to the persisted store module,
       * so it survives a page reload before the confirmation page mounts.
       * @param {Object} gaInfo
       * @return void
       */
      persistPendingPurchaseGaInfo(gaInfo) {
        this.$store.commit('persisted/SET_PENDING_PURCHASE_GA_INFO', JSON.parse(JSON.stringify(gaInfo)));
      },

      /**
       * Clear the pending purchase GA info from the persisted store module.
       * @return void
       */
      clearPendingPurchaseGaInfo() {
        this.$store.commit('persisted/CLEAR_PENDING_PURCHASE_GA_INFO');
      },

      /**
       * Scrolls page to current error on erros object
       * @return void
       */
      scrollToError() {
        const firstField = Object.keys(this.errors.collect())[0];
        const element = this.$el.querySelector(`[name="${firstField}"]`);

        if (element.offsetParent) {
          element.scrollIntoView();
        }
        else {
          //if element is not visible scroll to its parent
          element.parentElement.scrollIntoView();
        }
      },

    /**
     * Get producs stock file from the CDN
     */
     getStockFile() {

       let base_url = this.$store.getters.getAccount.name.includes("--aws--") ? process.env.VUE_APP_CDN77_BASE_AWS : process.env.VUE_APP_CDN77_BASE;

       var url = base_url+'/stock/'+this.$store.getters.getAccount.id+'.json';

        this.$axios({
          url: url,
          method: 'get'

        }).then((result) => {
          if(result.data) {
            this.$store.commit('UPDATE_PRODUCTS_STOCK', result.data);
          }
        }).catch((error) => {
          //sends an airbake alert
        });

    },


    /**
     * Get referral scheme file from the CDN
     */
    getReferralSchemeFile  (slug, redeemer_slug) {

      let base_url = this.$store.getters.getAccount.name.includes("--aws--") ? process.env.VUE_APP_CDN77_BASE_AWS : process.env.VUE_APP_CDN77_BASE;

      var url = base_url+'/referral_schemes/'+this.$store.getters.getAccount.id+'-'+slug+'.json';

       return this.$axios({
         url: url,
         method: 'get'

       }).then((result) => {
         if(result.data) {
          if(redeemer_slug){
            result.data.slug = redeemer_slug;
          }
           this.$store.commit('UPDATE_REFERRAL_SCHEME', result.data);
         }
       }).catch((error) => {
         //sends an airbake alert
       });

   },


   /**
     * Get referrer file from the CDN
     */
   getReferrerFile  (slug) {

    let base_url = this.$store.getters.getAccount.name.includes("--aws--") ? process.env.VUE_APP_CDN77_BASE_AWS : process.env.VUE_APP_CDN77_BASE;

    var url = base_url+'/referrers/'+this.$store.getters.getAccount.id+'-'+slug+'.json';

     return this.$axios({
       url: url,
       method: 'get'

     }).then((result) => {
       if(result.data) {
          this.$store.commit('UPDATE_REFERRER', result.data);
          return this.getReferralSchemeFile(result.data.referral_scheme_slug, slug);
       }
     }).catch((error) => {
       //sends an airbake alert
     });

 },

  formatMobile(value) {
       if(typeof value !== 'string') {
           return ''
       }
       const parsed = parsePhoneNumber(value, {defaultCountry: 'GB', extract: false});
       return parsed?.isValid() && parsed?.country === 'GB' ? parsed?.format('E.164') ?? '' : ''
  },
  
  getDigitalDeliveryPrice(fulfilment_method_id = 10) {
      const accountPrice = this.$store.getters.getAccount.DigitalDeliveryPrices?.find(ddp => ddp.fulfilment_method_id == fulfilment_method_id)
      const togglePrice = this.$store.getters.getToggleDigitalDeliveryPrices?.find(tdp=> tdp.fulfilment_method_id == fulfilment_method_id)
      return accountPrice ? accountPrice.price : (togglePrice?.price ?? 0)
  },
  
  allowMobileDelivery(product, delivery_type) {
      const accountHasFeature = this.$store.getters.getFeature(11)
      // We always select delivery type 1 but if sms is possible on the product we set here
      return delivery_type === 1 && !!accountHasFeature && !!product.FulfilmentMethods.find(fm => fm.id == 10)
  },
  
  /**
   * Converts a hex color to rgba with opacity
   * @param {string} hex - Hex color code
   * @param {number} opacity - Opacity value between 0 and 1
   * @return {string} RGBA color string
   */
  hexToRgba(hex, opacity) {
      hex = hex.replace('#', '');
      let r, g, b;
      if (hex.length === 3) {
          r = parseInt(hex[0] + hex[0], 16);
          g = parseInt(hex[1] + hex[1], 16);
          b = parseInt(hex[2] + hex[2], 16);
      } else {
          r = parseInt(hex.substring(0, 2), 16);
          g = parseInt(hex.substring(2, 4), 16);
          b = parseInt(hex.substring(4, 6), 16);
      }
      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    },

    /**
     * Convert a PHP date format to a JS date format
     *
     * @param {String} phpFormat
     * @param {Object} options
     * @param {String} options.dayFormat
     * @param {String} options.monthFormat
     * @param {String} options.yearFormat
     * @param {String} options.separator
     * @return {String}
     */
    phpDateFormatToJs(
        phpFormat,
        {
            dayFormat = "DD",
            monthFormat = "MM",
            yearFormat = "YYYY",
            separator = "/"
        } = {}
    )
    {
        // Map the formats, we want to keep the ordering
        const mapping = {
            d: dayFormat,
            m: monthFormat,
            Y: yearFormat
        };

        // Split on non-letter characters (the separators)
        const parts = phpFormat.split(/[^A-Za-z]/);
        const formattedParts = parts
            .map(p => mapping[p])
            .filter(Boolean);

        return formattedParts.join(separator);
    }
  }
}

